import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Button, DescriptiveText, Image, Page, Row, Tile} from '../../../shared';
import debug from 'debug';
import {_openModal} from '../../../shared/reducers/modals';
import {_getPartners} from '../../reducers/partners';
import {isEntitled} from '../../../shared/store';
import history from '../../../history';
import axiosInstance from '../../../shared/utils/axios';
import {open} from '../../../shared/utils/utils';
import PropTypes from 'prop-types';

const log = debug('circleblack:FinancialPlanning');

const FinancialPlanning = ({openModal, getPartners, partners}) => {
  log('rendering');
  const [portal, setPortal] = useState('');
  const mgpPartner = partners.findWhere({name: 'mgp'});
  const rcPartner = partners.findWhere({name: 'rightCapital'});

  const openRightCapitalLogin = () => {
    log('rightCapitalLogin clicked'); // ToDo: Verify right captial
    axiosInstance.get('/auth/rightCapital/login')
      .then(res => open('GET', res.data.value, null, '_blank'))
      .catch(err => openModal({type: 'Error', err}));
  };

  useEffect(() => {
    if (!portal) {
      getPartners();

      if (isEntitled([{group: 'partners', feature: 'mgp', access: 'r'}])
        && isEntitled([{group: 'partners', feature: 'rightCapital', access: 'r'}])) {
        setPortal('both');
      } else {
        if (isEntitled([{group: 'partners', feature: 'mgp', access: 'r'}])) {
          setPortal('mgp');
          history.push('/analyze/financialPlanning/mgp');
        }
        if (isEntitled([{group: 'partners', feature: 'rightCapital', access: 'r'}])) {
          setPortal('rightCapital');
          openRightCapitalLogin();
        }
      }
    }
  }, []);

  return <Page>
    <Tile key='Financial Planning' title='Financial Planning'>
      {portal === 'both' ? <div>
        <DescriptiveText>
          <p>You can link CircleBlack with one of the platforms below to gain access to financial planning and additional features
            they provide on the accounts you manage. Just click the platform you want and either log in to an existing account or
            sign up.</p>
        </DescriptiveText>
        <Row wrap={false}>
          {/*TODO Reqs max  width*/}
          {rcPartner
          && <Image src={rcPartner.logo}
                    margin={'5px'}
                    maxHeight={'50px'}
                    action={() => {
                      setPortal(rcPartner.name);
                      openRightCapitalLogin();
                    }}/>}
          {/*TODO Reqs max  width*/}
          {mgpPartner
          && <Image src={mgpPartner.logo}
                    margin={'5px'}
                    maxHeight={'50px'}
                    action={() => {
                      setPortal(mgpPartner.name);
                      history.push('/analyze/financialPlanning/mgp');
                    }}/>}
        </Row>
      </div> : null}
      {portal === 'rightCapital' ? <Button
        importance={'primary'}
        size={'lg'}
        label={'Update Credentials'}
        disabled={false}
        action={openRightCapitalLogin}>
      </Button> : null}
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  partners: state.partners,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getPartners: () => dispatch(_getPartners()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinancialPlanning);

FinancialPlanning.propTypes = {
  openModal: PropTypes.func,
  /**
   * Gathers the list of partners
   */
  getPartners: PropTypes.func.isRequired,
  /**
   * Partners object
   */
  partners: PropTypes.object,
};
